import { TEMP_WHITE_LIST, } from "@bracket/whitelist";
import * as G from "@globals";




export const walletIsWhiteList = async () => {
	const { address, } = G.wallet.getBracketWallet();
	if(address === import.meta.env.VITE_ANON_WALLET_ADDR) {
		return false;
	}
	return Boolean(Object.keys(TEMP_WHITE_LIST).find(addr => addr.toLowerCase() === address?.toLowerCase()));
}
